import React from 'react'
import { Grid, Link, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  cardParagraph: {
    fontFamily: 'Poppins',
    color: theme.palette.text.secondary,
    display: 'block',
  },

  cardParagraphSpan: {
    position: 'relative',
    bottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  cardIcon: {
    marginRight: theme.spacing(1),
  },
}))

const IconWithLabel = ({ Icon, value, isBold, href }) => {
  const classes = useStyles()
  const children = (
    <>
      <Icon fontSize='default' color='primary' className={classes.cardIcon} />
      <span className={classes.cardParagraphSpan}>{value}</span>
    </>
  )

  return (
    <Grid item xs={12}>
      <Typography
        paragraph
        className={classes.cardParagraph}
        style={{ fontWeight: isBold ? 'bold' : '' }}
      >
        {href ? (
          <Link href={href} target='_blank' rel='noopener noreferrer'>
            {children}
          </Link>
        ) : (
          children
        )}
      </Typography>
    </Grid>
  )
}

export default IconWithLabel
